<template>
  <div 
    class="thumb-card resizeable-thumbnail" 
    @click="$emit('click')"
    :style="proofcardStyle">
    <v-progress-circular v-if="isLoading" class="escalon-absolute-center" indeterminate />
    <div v-else 
      class="escalon-background-image" 
      :style="style" 
      :title="title"/>

    <v-icon v-if="isVideo" :style="iconStyle" :color="colorHex">fas fa-film</v-icon>
   <thumbnail-misc v-if="showMisc"
     :imgSize="imgSize"
     :thumbnailAnnotation="thumbnailAnnotation" 
     :showDropdown="showDropdown"
     :proofsheet="true"
     @multiview-launch="multiviewLaunch"/>
    <span class="thumb-timestamp">{{image.imgTimeStamp}}</span>
    <span class="thumb-date">{{dateIndexString}}</span>
    <span class="thumb-eye">{{image.imgEye}}</span>
    <v-checkbox 
      class="thumb-checkbox"
      :color="colorHex"
      :input-value="isSelected"
      @click.stop="$emit('clickCheckbox')"></v-checkbox>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import thumbnailMisc from "./ThumbnailMisc";
import store from "../../store";
import thumbnailUtl from "../mixins/ThumbnailUtl";

export default {
  name: "ResizableThumbnail",
    components: { thumbnailMisc },
  props: {
    image: Object,
    scale: Number
  },
  methods:{
    multiviewLaunch(launchOption){
      this.$store.dispatch("openOCTMultiviewFromThumbnail", {image: this.image, launchOption: launchOption});
    }
  },
  mixins: [thumbnailUtl],
  computed: {
     ...mapGetters(["exams"]),
    exam(){
      return store.getters.examBySrNo(this.image.exSrNo);
    },
    isCirrus(){
      return this.exam && this.exam.browserType == "Cirrus";
    },
    imgSize(){
      return{
        w: 500 * this.scale,
        h: 500 * this.scale
      }
    },
    inf(){
      return require("../../assets/INF.png");
    },
    imageSrc(){
      if (!this.image) return "";
      if (this.image.proofNotFound) return this.inf;
      return this.image.proofObjectUrl;
    },
    style(){
      return { "background-image": "url('" + this.imageSrc + "')" };
    },
    proofcardStyle() {
      if (this.image.isAnnotated) 
        return {
          "border": "2px solid " + this.colorHex,
          "width": 500 * this.scale + "px",
          "height": 500 * this.scale + "px"
        };
      return {
        "width": 500 * this.scale + "px",
        "height": 500 * this.scale + "px"
      };
    },
    title(){
      if (this.image.proofNotFound) return "Image Not Found";
      return "Image #" + (this.image.exIndex);
    },
    isLoading() {
      return this.image.proofIsLoading;
    },
    isSelected(){
      return this.$store.getters.imageIsSelectedInProofsheet(this.image);
    },
    dateIndexString() {
      return this.image.exDateDisplay + " (" + this.image.exIndex + ")";
    },
    isVideo() {
      return this.image.imgType == "VIDEO";
    },
    iconStyle() {
      return {
        "position": "absolute",
        "left": 220 * this.scale + "px",
        "top": 220 * this.scale + "px"
      };
    }
  }
};
</script>